module.exports = __webpack_public_path__ + "img/dashboard.efb84b16.jpg";